



























import { defineComponent, ref, watch } from '@vue/composition-api';
import { DataTableHeader } from 'vuetify';
import { useUsers } from '@/store/modules/users';
import ApiKeyChip from './ApiKeyChip.vue';

export default defineComponent({
	components: { ApiKeyChip },
	setup(_, { root }) {
		const search = ref<string>('');
		const page = ref<number>(1);
		const headers: DataTableHeader[] = [
			{ text: 'ID', value: 'id' },
			{ text: 'Email', value: 'email' },
			{ text: 'API keys', value: 'apiKeys', sortable: false },
		];

		const { users, isLoading, isLoaded, hasError, error } = useUsers(root.$store);

		const handleRefetch = () => {
			root.$store.dispatch('users/getUsers');
		};

		watch(search, () => (page.value = 1));

		return {
			search,
			page,
			headers,
			users,
			isLoading,
			isLoaded,
			hasError,
			handleRefetch,
		};
	},
});
